export default {
	stage: 'prd',
	studentApiBaseUrl: 'https://studentapi.prtl.co',
	hubUrl: 'https://studentsystem.prtl.co/studentjs/dist/storageHub.html?v2',
	serviceLayerBaseUrl: 'https://reflectorjwt.prtl.co',
	wishlistServiceBaseUrl: 'https://decisionmakingapi.prtl.co',
	tokenServiceBaseUrl: 'https://tokens.prtl.co',
	wssEndpoint: 'wss://studentwebsocketservice.prtl.co/v1',
	PUBLIC_ROLLBAR_TOKEN: 'd597d60d3a464048a2576b8529714d8f39a2694110351372e360a12a5a9900edba5d3e2988931b484194f226080ea5d7'
};
